// extracted by mini-css-extract-plugin
export default {"contentBlockWrapper":"hireSkip_contentBlockWrapper__fMkMc","productCardWrapper":"hireSkip_productCardWrapper__KxagP","cardsGridWrapper":"hireSkip_cardsGridWrapper__HZe4t"};